<template lang="pug">
  v-flex.main(xs12)
    v-layout(row wrap)
      template(v-for='(item, index) in items' row wrap)
        v-flex(xs3 :key='item.key + index')
          strong {{ item.label }}:
        v-flex(xs3 :key='item.key + index + 9') {{ item.value }}
</template>

<script>
export default {
  props: {
    component: {
      type: Object
    },
    formKey: {
      type: String
    },
    formKeyRecursiveNum: {
      type: Array
    },
    values: {
      type: Object
    }
  },
  computed: {
    items () {
      const { formKey, formKeyRecursiveNum, component, values } = this
      let KEY = formKey + '.' + component.key
      if (formKeyRecursiveNum) {
        formKeyRecursiveNum.forEach(item => {
          KEY = KEY.replace('$', '_' + item)
        })
      }

      const matchValues = Object.entries(values)
        .filter(([key, value]) => key.indexOf(KEY) > -1)
        .reduce((acc, item) => {
          if (item[0].split('.').includes('obs')) {
            acc[acc.length - 1][1] = item[1]
          } else {
            acc = [
              ...acc,
              item
            ]
          }

          return acc
        }, [])
      let mapColumns = {}
      component.columns.forEach(item => {
        mapColumns[item.value] = item.label
      })
      let mapRows = {}
      component.rows.forEach(item => {
        mapRows[item.key] = item.label
      })
      return matchValues.map(item => {
        return {
          label: mapRows[item[0].split('.').pop()],
          key: item[0],
          value: mapColumns[item[1]] || item[1]
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

  .main
    margin 10px 0!important
    >>> .flex
      padding-bottom 2px!important
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/components/FieldComponentTable.vue